import config from "../config";

export const getCanvasValues = (shapeInputValues, currentShape, lineAlignment) => {
  
  const { top, left, right, bottom } = shapeInputValues;
  const { defaultRatio } = config;

  // const _canvasLeft =  lineAlignment === "horizontal" && currentShape === "left" ? ( left / defaultRatio + right / defaultRatio) :  left / defaultRatio;
  // const _canvasRight =  lineAlignment === "horizontal" && currentShape === "right" ? ( left / defaultRatio + right / defaultRatio) :  right / defaultRatio;

  // const canvasTop = lineAlignment === "vertical" ? (top /defaultRatio+ bottom/defaultRatio) : top / defaultRatio  ;
  // const canvasLeft = _canvasLeft;
  // const canvasBottom =
  //   currentShape === "right"
  //     ? canvasTop - bottom / defaultRatio
  //     : bottom / defaultRatio;
  // const canvasRight = _canvasRight;


  //remove this if this task has any comment 
  //https://app.clickup.com/t/20509883/HDL-974886
  //uncomment above code

  const canvasTop = top / defaultRatio;
  const canvasLeft = left / defaultRatio;
  const canvasBottom =
    currentShape === "right"
      ? canvasTop - bottom / defaultRatio
      : bottom / defaultRatio;
  const canvasRight = right / defaultRatio;


  return {
    canvasTop,
    canvasLeft,
    canvasRight,
    canvasBottom,
  };
};

export const wrtRatio = (value, operator = "/") => {
  const defaultRatio = config.defaultRatio;

  if (operator === "/") return value / defaultRatio;
  if (operator === "*") return value * defaultRatio;
  if (operator === "+") return value + defaultRatio;
  if (operator === "-") return value - defaultRatio;

  throw new Error(`Unsupported operator: ${operator}`);
};
